import { Link, useLoaderData } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { ScientificEntryDto } from '../application/dto/ScientificEntryDto';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import { staticSeo } from '../../../app/seo/static-seo.content';
import './ScientificEntryListPage.css';

export interface ScientificEntryListLoaderData {
  heading: string;
  basePath: string;
  entries: ScientificEntryDto[];
}

/**
 * Used for both `/mineralogy` and `/petrology` — the two only ever differed
 * by category, heading text and URL prefix, all of which the route loader
 * already resolves (see app/routes.tsx), so one component serves both
 * instead of two near-identical copies.
 */
export function ScientificEntryListPage() {
  const { heading, basePath, entries } = useLoaderData() as ScientificEntryListLoaderData;
  // basePath ('/mineralogy' or '/petrology') picks the matching static SEO
  // entry — derived here in the presentation layer rather than adding a
  // `seo` field to the ScientificEntry domain model, which this Sprint's
  // scope explicitly preserves as-is.
  useDocumentHead(basePath === '/petrology' ? staticSeo.petrologyList : staticSeo.mineralogyList);

  return (
    <Container>
      <section className="dma-scientific-list">
        <h1>{heading}</h1>

        {entries.length === 0 ? (
          <p className="dma-scientific-list__empty">هنوز مطلبی در این بخش منتشر نشده است.</p>
        ) : (
          <div className="dma-scientific-list__grid">
            {entries.map((entry) => (
              <Link key={entry.id} to={`${basePath}/${entry.slug}`} className="dma-scientific-list__card">
                {entry.images[0] ? (
                  <img src={entry.images[0].url} alt={entry.title} loading="lazy" />
                ) : (
                  <div className="dma-scientific-list__card-placeholder" aria-hidden="true" />
                )}
                <div className="dma-scientific-list__card-body">
                  <h2>{entry.title}</h2>
                  <p>{entry.classification}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </Container>
  );
}
